//
//
//
//
//
//

/**
 * Original Author: Paul Roberts
 * Original Team: Mavericks
 *
 * NsBifrostButton is the only Vue based button. This button renders as a normal
 * button but has JavaScript under the hood to handle the moving gradient
 * background effect. The button has a single slot where content can be put. The
 * most logical thing to include are icons and text although this isn't
 * restricted.
 *
 * The Bifrost Button also inherits its styles from
 * @nuskin/ns-core-styles so classes like fluid and short work with it as well.
 */
export default {
  name: 'NsBifrostButton',
  props: {
    /**
     * type="hit" will give you a black based button,
     * type="ghost" will give you a ghost based button
     */
    type: {
      type: String,
      default: 'hit',
    },
  },
  data() {
    return {
      buttonType: 'primary-solid',
    };
  },
  mounted() {
    if (this.type === 'ghost') {
      this.buttonType = 'primary-ghost';
    } else {
      this.buttonType = 'primary-solid';
    }

    this.$el.style.setProperty('--ns-button-gradient-position', '-102%');
    this.$el.addEventListener('mousemove', (e) => {
      this.$el.style.setProperty(
        '--ns-button-gradient-position',
        ((e.pageX - this.$el.offsetLeft) / this.$el.offsetWidth) * 100 + '%'
      );
    });

    this.$el.addEventListener('mouseleave', () => {
      this.$el.style.setProperty('--ns-button-gradient-position', '-102%');
    });
  },
};
